import { get } from '../../../utils/state';

export const getArrivalInitialized = state => get(state, 'authentication.arrivalInitialized', false);

export const getProfileKey = state => get(state, 'authentication.profileKey', '');

export const getCurrentProfile = (state) => {
  const profileKey = getProfileKey(state);

  return profileKey ? get(state, `entities.profiles.data.${profileKey}`) : null;
};

export const isProfileKnown = state => get(state, 'authentication.profileStatus.known', false);

export const isProfileClaimed = state => get(state, 'authentication.profileStatus.claimed', false);

export const getKnownProfileKey = state => get(state, 'authentication.profileStatus.profileKey', '');

export const getIsAuthenticated = state => get(state, 'authentication.isAuthenticated', false);

export const getPreferredJobTitles = profileKey => state => get(state, `entities.profiles.data.${profileKey}.job_search_job_titles`, '');

export const getProfileIsLoading = state => get(state, 'authentication.isLoading', false);

export const getPreferredJobLocation = profileKey => state => get(state, `entities.profiles.data.${profileKey}.job_search_location`, '');

export const getUserEnteredLocation = profileKey => (state) => {
  const userCity = get(state, `entities.profiles.data.${profileKey}.city`);
  const userState = get(state, `entities.profiles.data.${profileKey}.state`);
  const userZipcode = get(state, `entities.profiles.data.${profileKey}.zip_code`);

  return {
    city: userCity,
    state: userState,
    zipcode: userZipcode,
  };
};

export const getEmail = profileKey => state => get(state, `entities.profiles.data.${profileKey}.email`);

export const getZipCode = profileKey => state => get(state, `entities.profiles.data.${profileKey}.zip_code`, '');

export const getAuthenticationError = state => get(state, 'authentication.error', false);

export const getArrivalEmail = state => (state?.authentication?.profileStatus?.arrivalEmail || '');

export const getArrivalFirstName = state => (state?.authentication?.profileStatus?.arrivalFirstName || '');

export const getArrivalLastName = state => (state?.authentication?.profileStatus?.arrivalLastName || '');

export const getIsLoginLoader = state => (state?.authentication?.isLoginLoader);

export const getIsSignupLoader = state => (state?.authentication?.isSignupLoader);

export const getLoginError = state => (state?.authentication?.loginError);

export default {
  getArrivalEmail,
  getArrivalFirstName,
  getArrivalInitialized,
  getArrivalLastName,
  getAuthenticationError,
  getCurrentProfile,
  getEmail,
  getIsAuthenticated,
  getIsLoginLoader,
  getIsSignupLoader,
  getKnownProfileKey,
  getPreferredJobLocation,
  getPreferredJobTitles,
  getProfileIsLoading,
  getProfileKey,
  getUserEnteredLocation,
  getZipCode,
  isProfileClaimed,
  isProfileKnown,
  getLoginError,
};
